import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { HolidaysMasterService } from 'src/app/services/holidays-master.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css']
})
export class HolidayComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  weeklyOffs: any[];
  error: any = { isError: false, errorMessage: '' };
  weeklyOffId: string;
  holidayId: string;
  weeklyMasterForm: FormGroup;
  holidayMasterForm: FormGroup;
  dateOfHoliday: NgbDateStruct;
  holidayDate: NgbDateStruct;
  todayDate: NgbDateStruct;
  chkCompanyFlag: boolean;
  chkStockExchangeFlag: boolean;
  chkMondayFlag: boolean;
  chkTuesdayFlag: boolean;
  chkWednesdayFlag: boolean;
  chkThursdayFlag: boolean;
  chkFridayFlag: boolean;
  chkSaturdayFlag: boolean;
  chkSundayFlag: boolean;
  dsblMonday: boolean;
  dsblTuesday: boolean;
  dsblWednesday: boolean;
  dsblThursday: boolean;
  dsblFriday: boolean;
  dsblSaturday: boolean;
  dsblSunday: boolean;
  dtTrigger: Subject<any> = new Subject();
  holidayTypes: any[];
  holidays: any[];
  deleteholidayId: any;
  weeklyValidationAlert: boolean;
  specialSaturday: any;
  specialSaturdayFromDate: NgbDateStruct;
  specialSaturdayToDate: NgbDateStruct;


  constructor(private holidaysMasterService: HolidaysMasterService,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private renderer: Renderer2,
    private customValidation: CustomValidation,
    private loaderService: LoaderService) { }


  getHolidayTypes() {
    this.holidayTypes = [
      { name: 'National' },
      { name: 'Public' }
    ];
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  showAddPopUp() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#holidayDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#holidayDialog').modal('show');
    }, 100);
    $('#btnsaveHoliday').show();
    $('#btnupdateHoliday').hide();
    this.draggableModelPopup();
    $("#holidayModalLabel").html('<i class="fa fa-plus"></i>Add Holiday');
    this.holidayMasterForm.reset();
    this.holidayId = "";
    this.holidayMasterForm.controls.IsGlobal.setValue('Company Specific');
    this.error = { isError: false, errorMessage: '' }
  }

  draggableModelPopup() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  addHoliday() {

    console.log("this.holidayMasterForm.controls.IsGlobal.value", this.holidayMasterForm.controls.IsGlobal.value);

    if (this.holidayMasterForm.status == "VALID") {

      var checkGlobal = null;


      if (this.holidayMasterForm.controls.IsGlobal.value == 'Company Specific') {
        checkGlobal = false
      } else if (this.holidayMasterForm.controls.IsGlobal.value == 'Global') {
        checkGlobal = true
      }

      else if (this.holidayMasterForm.controls.IsGlobal.value == 'Global') {
        checkGlobal = true;

      }
      else {
        checkGlobal = this.holidayMasterForm.controls.IsGlobal.value;
        console.log("else")

      }

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var newHoliday = {
        CompanyID: loginUsers.CompanyID,
        Description: this.holidayMasterForm.controls.Description.value,
        HolidayDate: this.setDate(this.holidayMasterForm.controls.HolidayDate.value),
        Company: this.holidayMasterForm.controls.Company.value,
        StockExchange: this.holidayMasterForm.controls.StockExchange.value,
        IsGlobal: checkGlobal,
        CreatedBy: loginUsers._id
      }
      this.holidaysMasterService.addHoliday(newHoliday)
        .subscribe(holiday => {
          if (holiday.status == 0) {
            $("#holidayDataTable").DataTable().ajax.reload();
            $('#holidayDialog').modal('hide');
            this.alert.successWithOk1(holiday.message, () => {
              $('#holidayDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
            });
            this.holidayMasterForm.reset();

          } else {
            $("#holidayDataTable").DataTable().ajax.reload();
            $('#holidayDialog').modal('hide');
            // this.alert.error( JSON.stringify(holiday.message) + ' fields are required or invalid.');
            // this.alert.error(holiday.message);
            if (holiday.message != undefined) {
              this.alert.error1(JSON.stringify(holiday.message) + ' fields are required or invalid.', () => {
                $('#holidayDialog').off('hidden.bs.modal');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
              });
            }
            else {
              this.alert.error(holiday.message);
            }
          }

        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  editHoliday() {
    if (this.holidayMasterForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = null;
      if (this.holidayMasterForm.controls.IsGlobal.value == 'Company Specific') {
        checkGlobal = false
      } else if (this.holidayMasterForm.controls.IsGlobal.value == 'Global') {
        checkGlobal = true
      }
      else {
        checkGlobal = this.holidayMasterForm.controls.IsGlobal.value;
        console.log("else")

      }
      var updatedHoliday = {
        _id: this.holidayId,
        Description: this.holidayMasterForm.controls.Description.value,
        Company: this.holidayMasterForm.controls.Company.value,
        StockExchange: this.holidayMasterForm.controls.StockExchange.value,
        IsGlobal: checkGlobal,
        HolidayDate: this.setDate(this.holidayMasterForm.controls.HolidayDate.value),
        ModifiedBy: loginUsers._id
      }
      this.holidaysMasterService.updateHoliday(updatedHoliday)
        .subscribe(holiday => {
          if (holiday.status == 0) {
            this.alert.success(holiday.message);
            this.holidayMasterForm.reset();
            $("#holidayDataTable").DataTable().ajax.reload();
            $('#holidayDialog').modal('toggle');
          } else {

            if (holiday.err_fields != undefined && holiday.err_fields != "") {
              this.alert.error(JSON.stringify(holiday.err_fields) + ' fields are required or invalid.');
            }
            else {
              this.alert.error(holiday.message);
            }
            $('#holidayDialog').modal('toggle');
            $("#holidayDataTable").DataTable().ajax.reload();
          }
        });
    }
    else {
      return false;
    }
  }

  loadHolidayToEdit(holidayId) {
    this.loaderService.disable();
    this.holidaysMasterService.getHolidayById(holidayId)
      .subscribe(holiday => {
        if (holiday.status == 0) {

          let dt = new Date(holiday.holidayData[0].HolidayDate);
          this.holidayDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
          this.draggableModelPopup();
          console.log("holiday.holidayData[0].IsGlobal", holiday.holidayData[0].IsGlobal)
          if (holiday.holidayData[0].IsGlobal != undefined && holiday.holidayData[0].IsGlobal != null) {
            if (holiday.holidayData[0].IsGlobal == true) {
              this.holidayMasterForm.controls.IsGlobal.setValue('Global');
            }
            else if (holiday.holidayData[0].IsGlobal == false) {
              this.holidayMasterForm.controls.IsGlobal.setValue('Company Specific');
            }
            else {
            }

          }
          this.holidayId = holiday.holidayData[0]._id;
          this.chkCompanyFlag = holiday.holidayData[0].HolidayTypeCompany;
          this.chkStockExchangeFlag = holiday.holidayData[0].HolidayTypeStockExchange;
          this.holidayMasterForm.controls.Company.setValue(holiday.holidayData[0].HolidayTypeCompany);
          this.holidayMasterForm.controls.StockExchange.setValue(holiday.holidayData[0].HolidayTypeStockExchange);
          this.holidayMasterForm.controls.Description.setValue(holiday.holidayData[0].Description);
          this.holidayMasterForm.controls.HolidayDate.setValue(this.holidayDate);
          $('#holidayDialog').modal('toggle'); //
          $("#holidayModalLabel").html('<i class="fa fa-pencil"></i> Update Holiday');
          $('#btnsaveHoliday').hide();
          $('#btnupdateHoliday').show();
          this.error = { isError: false, errorMessage: '' }
        }
      });
  }


  deleteConfirmation(holidayId) {
    this.holidayId = holidayId
    $('#confirmation').modal('toggle');
  }

  deleteHoliday() {
    console.log("this.holidayId", this.deleteholidayId);
    this.holidaysMasterService.deleteHoliday(this.deleteholidayId).subscribe(data => {
      if (data.status == 0) {

        this.alert.success(data.message);
        $("#holidayDataTable").DataTable().ajax.reload();
        $('#confirmation').modal('toggle');
      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
      }

      // if (this.dtElement.dtInstance != undefined) {
      //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //     dtInstance.destroy();
      //   });
      // }
      // this.getHolidayList();
    });
  }

  updateWeeklyOff() {
    this.weeklyValidationAlert = false;
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    var checkGlobalweek = true;
    if (this.weeklyMasterForm.controls.IsGlobalweekly.value == 'Company Specific') {
      checkGlobalweek = false
    }

    var updatedWeeklyOff = {
      _id: this.weeklyOffId,
      CompanyID: loginUsers.CompanyID,
      Monday: this.weeklyMasterForm.controls.Monday.value,
      Tuesday: this.weeklyMasterForm.controls.Tuesday.value,
      Wednesday: this.weeklyMasterForm.controls.Wednesday.value,
      Thursday: this.weeklyMasterForm.controls.Thursday.value,
      Friday: this.weeklyMasterForm.controls.Friday.value,
      Saturday: this.weeklyMasterForm.controls.Saturday.value,
      Sunday: this.weeklyMasterForm.controls.Sunday.value,
      specialSaturday: this.specialSaturday,
      ModifiedBy: loginUsers._id,
      IsGlobalweekly: checkGlobalweek
    }

    console.log("updatedWeeklyOff", updatedWeeklyOff);

    this.holidaysMasterService.updateWeeklyOff(updatedWeeklyOff)
      .subscribe(weeklyOff => {
        if (weeklyOff.status == 0) {
          this.alert.success(weeklyOff.message);
          this.holidayMasterForm.reset();
        } else {
          this.alert.error(weeklyOff.message);
        }
        this.getWeeklyOffList();
      });
  }

  updateWeeklyOff1() {
    this.weeklyValidationAlert = false;
    var loginUsers = JSON.parse(localStorage.getItem("user"));
    var checkGlobalweek = true;
    if (this.weeklyMasterForm.controls.IsGlobalweekly.value == 'Company Specific') {
      checkGlobalweek = false
    }

    var updatedWeeklyOff = {
      _id: this.weeklyOffId,
      CompanyID: loginUsers.CompanyID,
      Monday: this.weeklyMasterForm.controls.Monday.value,
      Tuesday: this.weeklyMasterForm.controls.Tuesday.value,
      Wednesday: this.weeklyMasterForm.controls.Wednesday.value,
      Thursday: this.weeklyMasterForm.controls.Thursday.value,
      Friday: this.weeklyMasterForm.controls.Friday.value,
      Saturday: this.weeklyMasterForm.controls.Saturday.value,
      Sunday: this.weeklyMasterForm.controls.Sunday.value,
      specialSaturday: this.specialSaturday,
      ModifiedBy: loginUsers._id,
      IsGlobalweekly: checkGlobalweek
    }

    console.log("updatedWeeklyOff", updatedWeeklyOff);

    this.holidaysMasterService.updateWeeklyOff(updatedWeeklyOff)
      .subscribe(weeklyOff => {
        if (weeklyOff.status == 0) {
          // this.alert.success(weeklyOff.message);
          this.holidayMasterForm.reset();
        } else {
          // this.alert.error(weeklyOff.message);
        }
        this.getWeeklyOffList();
      });
  }

  getWeeklyOffList() {
    this.weeklyOffs = [];
    this.holidaysMasterService.getWeeklyOffList()
      .subscribe(weeklyOffList => {
        if (weeklyOffList.status == 0) {
          this.weeklyOffs = weeklyOffList.companyWeeklyOffsResult;
          this.weeklyOffId = weeklyOffList.companyWeeklyOffsResult[0]._id;

          this.chkMondayFlag = weeklyOffList.companyWeeklyOffsResult[0].Monday;
          this.chkTuesdayFlag = weeklyOffList.companyWeeklyOffsResult[0].Tuesday;
          this.chkWednesdayFlag = weeklyOffList.companyWeeklyOffsResult[0].Wednesday;
          this.chkThursdayFlag = weeklyOffList.companyWeeklyOffsResult[0].Thursday;
          this.chkFridayFlag = weeklyOffList.companyWeeklyOffsResult[0].Friday;
          this.chkSaturdayFlag = weeklyOffList.companyWeeklyOffsResult[0].Saturday;
          this.chkSundayFlag = weeklyOffList.companyWeeklyOffsResult[0].Sunday;
          this.specialSaturday = weeklyOffList.companyWeeklyOffsResult[0].specialSaturday;
          if (weeklyOffList.companyWeeklyOffsResult[0].IsGlobalweekly != undefined) {
            if (weeklyOffList.companyWeeklyOffsResult[0].IsGlobalweekly == true) {
              this.weeklyMasterForm.controls.IsGlobalweekly.setValue('Global');
            }
            else {
              this.weeklyMasterForm.controls.IsGlobalweekly.setValue('Company Specific');
            }
          }

          this.weeklyMasterForm.controls.Monday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Monday);
          this.weeklyMasterForm.controls.Tuesday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Tuesday);
          this.weeklyMasterForm.controls.Wednesday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Wednesday);
          this.weeklyMasterForm.controls.Thursday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Thursday);
          this.weeklyMasterForm.controls.Friday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Friday);
          this.weeklyMasterForm.controls.Saturday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Saturday);
          this.weeklyMasterForm.controls.Sunday.setValue(weeklyOffList.companyWeeklyOffsResult[0].Sunday);
        }
        else {
          //----Comment on below 0: if recordes is not preesent in DB for login company than new record have to insert,0 use at API level.
          this.weeklyOffId = "0";
        }
      })
  }

  ValidateWeeklyOff(event) {
    this.weeklyValidationAlert = false;
    if (event.target.checked == true) {
      var weeklyOffs = [];
      weeklyOffs[0] = this.weeklyMasterForm.controls.Monday.value;
      weeklyOffs[1] = this.weeklyMasterForm.controls.Tuesday.value;
      weeklyOffs[2] = this.weeklyMasterForm.controls.Wednesday.value;
      weeklyOffs[3] = this.weeklyMasterForm.controls.Thursday.value;
      weeklyOffs[4] = this.weeklyMasterForm.controls.Friday.value;
      weeklyOffs[5] = this.weeklyMasterForm.controls.Saturday.value;
      weeklyOffs[6] = this.weeklyMasterForm.controls.Sunday.value;

      var validateCount = 0;
      for (var i = 0; i < weeklyOffs.length; i++) {
        if (weeklyOffs[i] == true) {
          validateCount++;
        }
      }
      if (validateCount >= 2) {
        this.dsblMonday = !this.weeklyMasterForm.controls.Monday.value;
        this.dsblTuesday = this.weeklyMasterForm.controls.Tuesday.value;
        this.dsblWednesday = this.weeklyMasterForm.controls.Wednesday.value;
        this.dsblThursday = this.weeklyMasterForm.controls.Thursday.value;
        this.dsblFriday = this.weeklyMasterForm.controls.Friday.value;
        this.dsblSaturday = this.weeklyMasterForm.controls.Saturday.value;
        this.dsblSunday = this.weeklyMasterForm.controls.Sunday.value;
        event.target.checked = false;
        this.weeklyValidationAlert = true;
      }
    }
  }

  getHolidayList() {
    this.holidays = [];
    this.holidaysMasterService.getHolidaysList()
      .subscribe(holidaysList => {
        if (holidaysList.status == 0) {
          // console.log(holidaysList.holidaysResult);
          this.holidays = holidaysList.holidaysResult;
          this.dtTrigger.next();
        }
      })
  }

  roundDigit(val) {

    var str = new String(val);
    // console.log(val,'-----length',str.length);
    if (str.length == 1) {
      // console.log(parseInt(0+''+val));
      return (0 + '' + val);
    } else {
      return parseInt(val);
    }
  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {

    this.environmentSettings = environment;

    this.commonFunction.validateURL('Holiday', '');

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }]
    };

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate() + 1;
    var year = dateObj.getUTCFullYear();
    this.todayDate = { year: year, month: month, day: day };

    this.weeklyValidationAlert = false;
    this.holidayMasterForm = new FormGroup({
      Company: new FormControl(''),
      StockExchange: new FormControl(''),
      Description: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      IsGlobal: new FormControl(''),
      HolidayDate: new FormControl('', [Validators.required])
    });



    this.weeklyMasterForm = new FormGroup({
      Monday: new FormControl(''),
      Tuesday: new FormControl(''),
      Wednesday: new FormControl(''),
      Thursday: new FormControl(''),
      Friday: new FormControl(''),
      Saturday: new FormControl(''),
      Sunday: new FormControl(''),
      IsGlobalweekly: new FormControl(''),
    });
    this.getHolidayList();
    //this.getHolidayTypes();
    this.getWeeklyOffList();
    let self = this;
    var token = localStorage.getItem('token')
    this.dtOptions2 = {
      ajax: {
        url: environment.pssServerUrl + "dataTable/getHolidays/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'get',
        headers: { "x-access-token": token },
        cache: true
      },
      columns: [
        {
          title: 'Holiday Date',
          width: '20%',
          render: function (data: any, type: any, full: any) {
            return '<span >' + self.roundDigit(new Date(full.HolidayDate).getDate()) + '-' + (new Date(full.HolidayDate).getMonth() + 1) + '-' + new Date(full.HolidayDate).getFullYear() + ''

          }
        },

        {
          title: 'Holiday Date',
          width: '20%',
          render: function (data: any, type: any, full: any) {
            return '<span style="display:none">' + full.HolidayDate + '</span>' + self.roundDigit(new Date(full.HolidayDate).getDate()) + '-' + (new Date(full.HolidayDate).getMonth() + 1) + '-' + new Date(full.HolidayDate).getFullYear() + ''

          }
        },
        {

          title: 'Description ',
          width: '20%',
          render: function (data: any, type: any, full: any) {

            return full.Description
          }
        }, {
          title: 'Holiday Type',
          width: '30%',
          render: function (data: any, type: any, full: any) {
            let str = '';
            let flag = true;
            if (full.HolidayTypeNational == true || full.HolidayTypeNational == 'true') {
              str = str + "<span class='badge badge-primary'>National</span>&nbsp;";
              flag = false;
            }
            if (full.HolidayTypeCompany == true || full.HolidayTypeCompany == 'true') {
              str = str + "<span class='badge badge-success'>Company Specific</span>&nbsp;"
              flag = false;
            }
            if (full.HolidayTypeStockExchange == true || full.HolidayTypeStockExchange == 'true') {
              str = str + "<span class='badge badge-default'>Stock Exchange</span>&nbsp;"
              flag = false;
            }
            if (flag) {
              str = "<span class='badge badge-danger'>Not Define</span>"
            }
            return str;

          }
        },
        {
          title: 'Global / Company Specific',
          width: '20%',
          render: function (data: any, type: any, full: any) {
            let str = '';
            let flag = true;
            if (full.IsGlobal == true || full.IsGlobal == 'true') {
              str = str + "<span class='badge badge-primary'>Global</span>&nbsp;";
              flag = false;
            }
            if (full.IsGlobal == false || full.IsGlobal == 'false') {
              str = str + "<span class='badge badge-success'>Company Specific</span>&nbsp;"
              flag = false;
            }
            return str;
          }
        },

        {
          title: 'Action',
          width: '10%',
          render: function (data: any, type: any, full: any) {
            if (self.commonFunction.validateModulePermitions('Holiday', '/holiday/edit?goveva=true&email=')) {
              // console.log(self.appHasPermission);
              return '<button [appHasPermission]="{Url: /holiday/edit?goveva=true&email=, method:put, menu: Holiday}" type="button"  update-holiday=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-holiday=' + full._id + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /holiday/edit?goveva=true&email=, method:put, menu: Holiday}" type="button" data-target="#confirmation" delete-holiday=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-holiday=' + full._id + '></span></button>';
            } else {
              return ''
            }
          }
        }],
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }, { className: "hide_col", targets: [0] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Holiday List',
          title: 'Holiday List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 4],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }

        }
      ]
    };
  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("update-holiday")) {
        console.log(event.target.getAttribute("update-holiday"));
        this.loadHolidayToEdit(event.target.getAttribute("update-holiday"))
        // this.loadholidayByIdToEdit(event.target.getAttribute("update-holiday"))
        // this.showCommitteeUpdatePopUp( event.target.getAttribute("update-committee"))
      }
      if (event.target.hasAttribute("delete-holiday")) {
        this.deleteholidayId = event.target.getAttribute("delete-holiday");
        console.log("id*", event.target.getAttribute("delete-holiday"));
        this.deleteConfirmation(event.target.getAttribute("delete-category"))
        //  this.showDeleteConfirmationPopUp(event.target.getAttribute("delete-category"))
      }
    });
  }

  changeNormalSaturdayValue() {
    this.weeklyMasterForm.controls.Saturday.setValue(null);
  }

  changeOtherSaturdayValue() {
    this.specialSaturday = null;
  }

  generateSaturdayOff() {
    console.log(this.specialSaturdayFromDate)
    console.log(this.specialSaturdayToDate)
    console.log(this.specialSaturday)
    var object = {
      fromDate: this.specialSaturdayFromDate,
      toDate: this.specialSaturdayToDate,
      saturdayType: this.specialSaturday
    }
    this.updateWeeklyOff1()
    this.holidaysMasterService.addSaturdayHoliday(object).subscribe(response => {
      if (response.status == 0) {
        this.getHolidayList();
        $("#holidayDataTable").DataTable().ajax.reload();
        this.alert.success('Holiday data added successfully')
      } else {
        this.alert.error('Oops something went wrong')
      }
    })
  }

}

